import Style, { type StyleProps } from "@client/controls/HTML/Style/component";
import { connectCustom } from "@client/lib/misc";
import { getLayoutSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { type WithRootSelector } from "../selectors";

const makeMapStateToProps = () => {
  const cssSelector = getLayoutSettingValueSelector("customCss");

  return (state: AppState, props: Partial<WithRootSelector>): StyleProps => ({
    css: cssSelector(state),
    rootSelector: props.rootSelector
  });
};

export default connectCustom(makeMapStateToProps)(Style);
